import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Action } from '@ngrx/store';
import { Actions, Effect } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { ModuleConfiguration } from '../messages.module.config';
import * as dashboardActions from '../../pillar/dashboard/store/actions';
import { MessagesListModel } from '../models/MessagesListModel';
import { MessagesModel } from '../models/MessagesModel';
import { DateFramedMessageModel } from '../models/DateFramedMessageModel';
import { ModelResponse } from '../../core/services/ModelResponse';
import { LoadPagePayload } from '../../pillar/common/actions/LoadPagePayload';

@Injectable()
export class MessagesService {

  constructor(public httpClient: HttpClient) {}

  getMessages(): Observable<ModelResponse<MessagesModel>> {
    return this.httpClient.get<ModelResponse<MessagesModel>>("/api/public/ConfigurationModule/Messages/GetMessages");
  }

  activateDisclaimer(): Observable<ModelResponse<string>> {
    return this.httpClient.post<ModelResponse<string>>(`/api/ConfigurationModule/Messages/ActivateDraftDisclaimer/`, '');
  }

  activateBroadcast(): Observable<ModelResponse<DateFramedMessageModel>> {
    return this.httpClient.post<ModelResponse<DateFramedMessageModel>>(`/api/ConfigurationModule/Messages/ActivateDraftBroadcast/`, '');
  }

  expireBroadcast(): Observable<ModelResponse<DateFramedMessageModel>> {
    return this.httpClient.post<ModelResponse<DateFramedMessageModel>>(`/api/ConfigurationModule/Messages/ExpireBroadcast/`, '');
  }

  expireNotification(model: DateFramedMessageModel): Observable<ModelResponse<DateFramedMessageModel>> {
    return this.httpClient.post<ModelResponse<DateFramedMessageModel>>(`/api/ConfigurationModule/Messages/ExpireNotification/`, { model: model });
  }

  reviseDraftDisclaimerDescription(key: string, disclaimerDescription: string): Observable<ModelResponse<string>> {
    return this.httpClient.post<ModelResponse<string>>(`/api/ConfigurationModule/Messages/${key}/ReviseDraftDisclaimerDescription/`, { model: disclaimerDescription['draftDisclaimerDescription'] });
  }

  reviseDraftBroadcastMessage(key: string, model: DateFramedMessageModel): Observable<ModelResponse<DateFramedMessageModel>> {
    return this.httpClient.put<ModelResponse<DateFramedMessageModel>>(`/api/ConfigurationModule/Messages/${key}/ReviseDraftBroadcastMessage/`, { model: model });
  }

  reviseActiveBroadcastMessage(key: string, model: DateFramedMessageModel): Observable<ModelResponse<DateFramedMessageModel>> {
    return this.httpClient.put<ModelResponse<DateFramedMessageModel>>(`/api/ConfigurationModule/Messages/${key}/ReviseActiveBroadcastMessage/`, { model: model });
  }

  addNotification(key: string, model: DateFramedMessageModel): Observable<ModelResponse<DateFramedMessageModel>> {
    return this.httpClient.put<ModelResponse<DateFramedMessageModel>>(`/api/ConfigurationModule/Messages/${key}/AddNotification/`, { model: model });
  }

  reviseNotification(key: string, model: DateFramedMessageModel): Observable<ModelResponse<DateFramedMessageModel>> {
    return this.httpClient.put<ModelResponse<DateFramedMessageModel>>(`/api/ConfigurationModule/Messages/${key}/ReviseNotification/`, { model: model });
  }
}



// WEBPACK FOOTER //
// ./src/app/messages/services/MessagesService.ts